import { queryOptions, useQuery } from '@tanstack/react-query';
import { getValidated, AppError } from '@shared/api';
import { pendingExpenseKeys } from './keys';
import { PendingExpenseListResponseSchema } from './schemas';
import { toPendingExpense } from './mappers';

/**
 * The logged-in user's pending expenses (`GET /api/v1/pending-expense?filter=…`). The server filters
 * by `filter` (`all` | `incomplete` | `unassigned`); the page only layers the archived toggle on top.
 * 404 is treated as empty.
 */
export function pendingExpensesQueryOptions(filter = 'all') {
  return queryOptions({
    queryKey: pendingExpenseKeys.list({ filter }),
    queryFn: async () => {
      try {
        const res = await getValidated('api/v1/pending-expense', PendingExpenseListResponseSchema, {
          filter,
        });
        return res.data?.expenses ?? [];
      } catch (error) {
        if (error instanceof AppError && error.status === 404) return [];
        throw error;
      }
    },
    select: (expenses) => expenses.map(toPendingExpense),
  });
}

export function usePendingExpenses(filter?: string) {
  return useQuery(pendingExpensesQueryOptions(filter));
}
